<div class="modal-content">
    <div class="modal-header" *ngIf="config.title">
      <span>
        <i [class]="config.icon"></i> {{ config.title }}
      </span>
    </div>
    <div class="modal-body">
        <p class="title">{{ config.question }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="ok($event)" appFocus>{{ config.okText }}</button>
        <button type="button" class="btn btn-secondary" (click)="cancel($event)">{{ config.cancelText }}</button>
    </div>
</div>
